var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone-01",
    clipPath: "url(#clip0_773_25532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.091 7.54474V8.99929C14.091 11.8109 11.8117 14.0902 9.00009 14.0902M3.90918 7.54474V8.99929C3.90918 11.8109 6.18846 14.0902 9.00009 14.0902M9.00009 14.0902V16.272M6.091 16.272H11.9092M9.00009 11.1811C7.7951 11.1811 6.81827 10.2043 6.81827 8.99929V3.90838C6.81827 2.7034 7.7951 1.72656 9.00009 1.72656C10.2051 1.72656 11.1819 2.7034 11.1819 3.90838V8.99929C11.1819 10.2043 10.2051 11.1811 9.00009 11.1811Z",
    stroke: "#332E29",
    strokeOpacity: 0.7,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_773_25532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4545,
    height: 17.4545,
    fill: "white",
    transform: "translate(0.272461 0.273438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.42d9bbf74d20d2de98bbbc398edbb2a4.svg";
export { ForwardRef as ReactComponent };